import { render, staticRenderFns } from "./Bandeau.vue?vue&type=template&id=d82b370a&"
import script from "./Bandeau.vue?vue&type=script&lang=js&"
export * from "./Bandeau.vue?vue&type=script&lang=js&"
import style0 from "./Bandeau.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports